var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "tab" }, [
    _c("ul", { staticClass: "tab-buttons" }, [
      _c(
        "li",
        {
          class: { active: _vm.isActive("register") },
          on: {
            click: function($event) {
              _vm.tab = "register"
            }
          }
        },
        [_vm._v("\n      Cadastro\n    ")]
      ),
      _vm._v(" "),
      _c(
        "li",
        {
          class: { active: _vm.isActive("schedule") },
          on: {
            click: function($event) {
              _vm.tab = "schedule"
            }
          }
        },
        [_vm._v("\n      Agenda\n    ")]
      ),
      _vm._v(" "),
      _c(
        "li",
        {
          class: { active: _vm.isActive("orders") },
          on: {
            click: function($event) {
              _vm.tab = "orders"
            }
          }
        },
        [_vm._v("\n      Pedidos\n    ")]
      ),
      _vm._v(" "),
      _c(
        "li",
        {
          class: { active: _vm.isActive("ratings") },
          on: {
            click: function($event) {
              _vm.tab = "ratings"
            }
          }
        },
        [_vm._v("\n      Avaliações\n    ")]
      ),
      _vm._v(" "),
      _c(
        "li",
        {
          class: { active: _vm.isActive("wallet") },
          on: {
            click: function($event) {
              _vm.tab = "wallet"
            }
          }
        },
        [_vm._v("\n      Carteira\n    ")]
      ),
      _vm._v(" "),
      _c(
        "li",
        {
          class: { active: _vm.isActive("districts") },
          on: {
            click: function($event) {
              _vm.tab = "districts"
            }
          }
        },
        [_vm._v("\n      Bairros\n    ")]
      ),
      _vm._v(" "),
      _c(
        "li",
        {
          class: { active: _vm.isActive("transfers") },
          on: {
            click: function($event) {
              _vm.tab = "transfers"
            }
          }
        },
        [_vm._v("\n      Transferências\n    ")]
      ),
      _vm._v(" "),
      _c(
        "li",
        {
          class: { active: _vm.isActive("biography") },
          on: {
            click: function($event) {
              _vm.tab = "biography"
            }
          }
        },
        [_vm._v("\n      Biografia\n    ")]
      ),
      _vm._v(" "),
      _c(
        "li",
        {
          class: { active: _vm.isActive("documents") },
          on: {
            click: function($event) {
              _vm.tab = "documents"
            }
          }
        },
        [_vm._v("\n      Documentos\n    ")]
      ),
      _vm._v(" "),
      _c(
        "li",
        {
          class: { active: _vm.isActive("background-check") },
          on: {
            click: function($event) {
              _vm.tab = "background-check"
            }
          }
        },
        [_vm._v("\n      Antecedentes\n    ")]
      ),
      _vm._v(" "),
      _c(
        "li",
        {
          class: { active: _vm.isActive("coupons") },
          on: {
            click: function($event) {
              _vm.tab = "coupons"
            }
          }
        },
        [_vm._v("\n      Cupons\n    ")]
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "tab-content" },
      [
        _c(
          "transition",
          { attrs: { name: "fade", mode: "out-in" } },
          [
            _c(_vm.tab, {
              tag: "component",
              attrs: { professional: _vm.professional },
              on: {
                refresh: function($event) {
                  return _vm.$emit("refresh")
                }
              }
            })
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2f47bda3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2f47bda3","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Professionals/Edit/Tabs/Index.vue
// module id = null
// module chunks = 